import { render, staticRenderFns } from "./CIncrustList.vue?vue&type=template&id=e87d630a&scoped=true&"
import script from "./CIncrustList.vue?vue&type=script&lang=js&"
export * from "./CIncrustList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87d630a",
  null
  
)

export default component.exports